/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '~/common/types/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type RecordUpdateLifecycle =
  | 'deactivate'
  | 'edit';

export type RecordUpdateProceedInput = {
  confirmationToken: string;
  dataImportProjectId?: string | null | undefined;
  evidenceIds?: Array<string> | null | undefined;
  keyRenames?: Array<RecordUpdatePropertyKeyRenameInput> | null | undefined;
  lifecycle?: RecordUpdateLifecycle | null | undefined;
  recordIds?: Array<string> | null | undefined;
  retypes?: Array<RecordUpdatePropertyRetypeInput> | null | undefined;
  tenantId: string;
};

export type RecordUpdatePropertyKeyRenameInput = {
  categories?: Array<string> | null | undefined;
  composers?: Array<string> | null | undefined;
  from: string;
  to: string;
};

export type RecordUpdatePropertyRetypeInput = {
  categories?: Array<string> | null | undefined;
  composers?: Array<string> | null | undefined;
  fromAttributeType?: string | null | undefined;
  fromType: string;
  key: string;
  toAttributeType?: string | null | undefined;
  toType: string;
};

export type ProceedRecordUpdateDataImportProjectMutationVariables = Exact<{
  input: Types.RecordUpdateProceedInput;
}>;


export type ProceedRecordUpdateDataImportProjectMutation = { cnutProceedRecordUpdateDataImportProject: { __typename: 'RecordUpdateProceedOutput', dataImportProjectId: string | null, dataSourceId: string | null, alreadyIdentifiedCount: number, unresolvableCount: number, batchEvidencesJobIds: Array<string>, batchChangeRequestsJobIds: Array<string> } };


export const ProceedRecordUpdateDataImportProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ProceedRecordUpdateDataImportProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RecordUpdateProceedInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cnutProceedRecordUpdateDataImportProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataImportProjectId"}},{"kind":"Field","name":{"kind":"Name","value":"dataSourceId"}},{"kind":"Field","name":{"kind":"Name","value":"alreadyIdentifiedCount"}},{"kind":"Field","name":{"kind":"Name","value":"unresolvableCount"}},{"kind":"Field","name":{"kind":"Name","value":"batchEvidencesJobIds"}},{"kind":"Field","name":{"kind":"Name","value":"batchChangeRequestsJobIds"}}]}}]}}]} as unknown as DocumentNode<ProceedRecordUpdateDataImportProjectMutation, ProceedRecordUpdateDataImportProjectMutationVariables>;